import * as React from 'react';
import { cn } from '@noor/lib/cn';

export type TopNavShellRootProps = React.ComponentProps<'div'>;

/**
 * Outer wrapper for the single-tier admin chrome used by super-app "parts" that
 * navigate through a horizontal top bar (as opposed to the icon-rail `AppShell`):
 * a full-width header pinned to the top, and the routed content filling the rest
 * of a full-height flex column.
 *
 * The shell fills whatever height its parent gives it (`h-full min-h-0`) — the
 * app owns the viewport (e.g. an `h-dvh` layout root), so the shell never
 * hardcodes viewport units.
 */
function TopNavShellRoot({ className, ...props }: TopNavShellRootProps) {
  return (
    <div
      data-slot="top-nav-shell"
      className={cn('flex h-full min-h-0 w-full flex-col', className)}
      {...props}
    />
  );
}

export { TopNavShellRoot };
